import { render, staticRenderFns } from "./KhsModal.vue?vue&type=template&id=dec31c8c&"
import script from "./KhsModal.vue?vue&type=script&lang=js&"
export * from "./KhsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports